import {
  AiConnectProjectType,
  AiConnectSegmentEvents,
  IAiConnectExitEvent,
  IAiConnectMessageSentEvent,
  IAiConnectModuleStartButtonClickedEvent,
  IAiConnectModuleViewedEvent,
  SegmentSchema,
} from '@sondermind/segment';
import { IPslPageLoadEventData } from './segment-event-data.interface';

export { AiConnectProjectType };

export enum PslSegmentEvents {
  PSL_PAGE_VIEW = 'Viewed a provider shareable link page',
  AI_CONNECT_MODULE_VIEWED = AiConnectSegmentEvents.AI_CONNECT_MODULE_VIEWED,
  AI_CONNECT_MODULE_START_BUTTON_CLICKED = AiConnectSegmentEvents.AI_CONNECT_MODULE_START_BUTTON_CLICKED,
  AI_CONNECT_MESSAGE_SENT = AiConnectSegmentEvents.AI_CONNECT_MESSAGE_SENT,
  AI_CONNECT_EXIT = AiConnectSegmentEvents.AI_CONNECT_EXIT
}

export interface IPslSegmentSchema extends SegmentSchema {
  [PslSegmentEvents.PSL_PAGE_VIEW]: IPslPageLoadEventData;
  [PslSegmentEvents.AI_CONNECT_MODULE_VIEWED]: IAiConnectModuleViewedEvent;
  [PslSegmentEvents.AI_CONNECT_MODULE_START_BUTTON_CLICKED]: IAiConnectModuleStartButtonClickedEvent;
  [PslSegmentEvents.AI_CONNECT_MESSAGE_SENT]: IAiConnectMessageSentEvent;
  [PslSegmentEvents.AI_CONNECT_EXIT]: IAiConnectExitEvent;
}
